import { render, staticRenderFns } from "./Schema.vue?vue&type=template&id=676eb1b2&scoped=true"
import script from "./Schema.vue?vue&type=script&lang=js"
export * from "./Schema.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676eb1b2",
  null
  
)

export default component.exports